/* eslint-disable max-statements */
import { userCanRegister } from "./authHelpers";

/**
 * Determines if the demographics popup should be shown to the user.
 *
 * @param {*} user The user to evaluate.
 * @param {*} cookies The cookies object.
 *
 * @returns boolean
 */
export const shouldAttendeeCompleteDemo = (user, cookies = null) => !!user &&
	!cookies?.lwc_is_user_switched &&
	userCanRegister(user) &&
	(
		// Demographics Completed value is false or not set
		!user?.attendeeDemographics?.demographicsCompleted ||
		// Profile Completed value is false or not set
		!user?.attendeeDetails?.profileCompleted ||
		// Any of the demographics fields are not set
		Object.entries(user?.attendeeDemographics || {}).
			some(([key, field]) => ["pronounsOther", "demographicsCompleted"].indexOf(key) === -1 &&
				// eslint-disable-next-line no-extra-parens
				(field === null || field === "" || (field.length === 1 && field[0] === null)))
	);

/**
 * Determines if the user should agree to the Terms of Use.
 *
 * @param {*} user The user to evaluate.
 * @param {*} cookies The cookies object.
 *
 * @returns boolean|string
 */
export const shouldAttendeeAgreeToTOU = (user, cookies = null) => {

	// If user is not logged in or is not an attendee.
	if (!user || !user?.attendeeId) {
		return false;
	}

	// If user is switched.
	if (cookies?.lwc_is_user_switched) {
		return false;
	}

	// If the current user is not an attendee.
	if (!userCanRegister(user)) {
		return false;
	}

	// If the terms agreed timestamp is not set.
	if (!user?.accountStatus?.termsAgreedTs) {
		return "notAgreed";
	}

	// If the terms agreed timestamp is more than a year old.
	if (new Date() - new Date(user?.accountStatus?.termsAgreedTs) > 31536000000) {
		return "annual";
	}

	// If lwcSiteSettings.waiver.last_update is set and is more recent than the terms agreed timestamp.
	if (
		window?.lwcSiteSettings?.waivers?.last_update &&
		new Date(user?.accountStatus?.termsAgreedTs) < new Date(window.lwcSiteSettings.waivers.last_update * 1000)
	) {
		return "newTerms";
	}

	return false;
};
